import { useEffect } from 'react';
import {
  useNotificationHandlerActions,
  useNotificationHandlerView,
} from '../notifications/notifications-handler-context';

export default function useResumeNotifications() {
  const { resumeNotifications } = useNotificationHandlerActions();
  const { newRfqCount } = useNotificationHandlerView();

  useEffect(() => {
    if (newRfqCount === 0) resumeNotifications();
  }, [resumeNotifications, newRfqCount]);
}
